
import RcDomainMap from "../../common/RcDomainMap.js";
import TimesheetEntry from './TimesheetEntry.js';

export default class TimesheetEntryMap extends RcDomainMap {
  static MODEL_NAME = TimesheetEntry.MODEL_NAME  + "Map";
  
  constructor(domain, data) {
    super(domain, data, TimesheetEntryMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new TimesheetEntryMap(this.domain, data);
  }
  
  sortByStartTimeId() {
    return this.list().sort(function(a, b) {
      if (a.timeIdStart() < b.timeIdStart()) {
        return -1;
      }
      if (a.timeIdStart() > b.timeIdStart()) {
        return 1;
      }
      return 0;
    });
  }
  
  /**
   * Each run the day had in a vehicle, in the order they started: the vehicle, the blocks it was
   * run for, and the readings it was taken on and put down at.
   *
   * <p>A run is the blocks sharing a vehicle <em>and</em> an opening reading - the same pairing
   * the apps use to stamp a closing reading across a run, and what tells one stint in a truck from
   * a later one in the same truck. Every block of a run carries the opening reading forward; the
   * closing one sits on the last block, so it is taken from whichever block has it.
   *
   * <p>Blocks with no vehicle are left out, so a day run without one gives an empty list.
   */
  vehicleRuns() {
    const runs = [];
    const byKey = {};
    for (const entry of this.sortByStartTimeId()) {
      if (!entry.hasVehicle()) {
        continue;
      }
      const key = entry.vehicle().id() + "|" + entry.startOdometer();
      let run = byKey[key];
      if (!run) {
        run = {
          vehicle: entry.vehicle(),
          first: entry,
          last: entry,
          startOdometer: entry.startOdometer(),
          endOdometer: "",
        };
        byKey[key] = run;
        runs.push(run);
      }
      run.last = entry;
      if (entry.hasEndOdometer()) {
        run.endOdometer = entry.endOdometer();
      }
    }
    for (const run of runs) {
      // Null until the truck has been put down: a run still going has no closing reading.
      run.distance = TimesheetEntry.distanceBetween(run.startOdometer, run.endOdometer);
    }
    return runs;
  }

  entryFor(timeId) {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var entry = this.getTimesheetEntry(key);
      if (timeId >= entry.timeIdStart() && timeId <= entry.timeIdEnd()) {
        return entry;
      }
    }
    return new TimesheetEntry(this.domain);
  }
  
  find() {
    var keys = this.keys();
    var found = new TimesheetEntryMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.timesheets().entries().findById(key);
      var item = new TimesheetEntry(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    
    return found;
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getTimesheetEntry(key);
      values.push(item);
    }
    return values;
  }
  
  getTimesheetEntry(key) {
    var value = super.get(key);
    return new TimesheetEntry(this.domain, value);
  }
}